import { render, staticRenderFns } from "./Generalview.vue?vue&type=template&id=6adaf0b3"
import script from "./Generalview.vue?vue&type=script&lang=js"
export * from "./Generalview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports